function fnv1aHex(input: string): string {
  let hash = 0x811c9dc5;
  for (let i = 0; i < input.length; i += 1) {
    hash ^= input.charCodeAt(i);
    hash += (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
  }
  return (hash >>> 0).toString(16).padStart(8, '0');
}

function normalizeStackLine(stack?: string): string {
  if (!stack) return '';
  const lines = stack
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean);
  return lines[1] ?? lines[0] ?? '';
}

export type StableErrorHashInput = {
  message: string;
  stack?: string;
  source: string;
  category: string;
  route?: string;
  service: string;
  releaseId?: string;
};

export function buildStableErrorHash(input: StableErrorHashInput): string {
  const normalized = [
    input.message.trim(),
    normalizeStackLine(input.stack),
    input.source,
    input.category,
    input.route ?? '',
    input.service,
    input.releaseId ?? '',
  ].join('|');
  return fnv1aHex(normalized);
}
